import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {AuthService} from '../../core/security/auth.service';
import {merge} from 'rxjs';
import {RolesEnum} from '../../core/security/roles.enum';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {FirewallService as FirewallApiService} from '../../api/services/firewall.service';
import {FirewallDatasource} from './firewall.datasource';
import {FirewallListRequest} from '../../api/models/firewall-list-request';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';

@Component({
    selector: 'app-firewall-grid',
    templateUrl: './firewall-grid.component.html',
    styleUrls: ['./firewall-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        RouterLink,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
        DateTimePipe,
    ],
})
export class FirewallGridComponent implements OnDestroy, OnInit, AfterViewInit {
  displayedColumns: string[] = ['ipAddress', 'startOn', 'endOn', 'customerNote', 'additionalNotes', 'notifyExpiration', 'recipients'];
  @Input() filterChangeEvent: EventEmitter<void>;
  @Input() showAdditionalColumns = false;
  hasSupportAccess = false;
  additionalFilter: any = {};
  recIdFilter: string;
  isLoading = false;
  searchText: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: FirewallDatasource;
  detailsUrl: string;
  hasEditAccess: boolean;

  constructor(public dialog: MatDialog,
              private firewallApiService: FirewallApiService,
              private route: ActivatedRoute, public headerService: HeaderService, public authService: AuthService) {
  }

  ngOnInit() {
    this.hasSupportAccess = this.authService.hasAccess([RolesEnum.Support]);
    this.hasEditAccess = this.authService.hasAccess([RolesEnum.Firewall_Edit, RolesEnum.Firewall_Delete]);
    this.dataSource = new FirewallDatasource(this.firewallApiService);

    this.detailsUrl = '../ipaddress';
  }

  ngAfterViewInit() {
    this.filterChangeEvent?.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): FirewallListRequest {
    const baseRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  ngOnDestroy() {
  }
}
